import { PatientInWindow } from "@/types/appointment";

import { requestData } from "@/api/api-config";

interface PatientsInWindowParams {
  providerId?: string;
  locationId?: string;
  minutesBefore?: number;
  minutesAfter?: number;
}

export async function getPatientsInWindow(
  params: PatientsInWindowParams = {},
): Promise<PatientInWindow[] | null> {
  return await requestData<PatientInWindow[]>("appointments/in-window", "get", {
    searchParams: {
      // FastAPI declares these as snake_case; the search-params layer
      // doesn't auto-rename, so passing the camelCase keys silently
      // drops the filters and falls back to the default window.
      ...(params.providerId ? { provider_id: params.providerId } : {}),
      ...(params.locationId ? { location_id: params.locationId } : {}),
      minutes_before: params.minutesBefore ?? 30,
      minutes_after: params.minutesAfter ?? 60,
    },
  });
}

export const appointmentsQueryKeys = {
  all: ["appointments"] as const,
  inWindow: (params: PatientsInWindowParams) =>
    [...appointmentsQueryKeys.all, "in-window", { ...params }] as const,
};

export const appointmentsQueryOptions = {
  inWindow: (params: PatientsInWindowParams) => ({
    queryKey: appointmentsQueryKeys.inWindow(params),
    queryFn: () => getPatientsInWindow(params),
  }),
};
